import {
  createSetFilters,
  createClearFilters,
  createSetFiltersFromSearchResults,
} from './setFilters';
import { filteredResultsVar, filtersVar, searchResultsVar } from '../reactiveVariables';

export const setFilters = createSetFilters(filtersVar, filteredResultsVar, searchResultsVar);
export const clearFilters = createClearFilters(filtersVar, filteredResultsVar, searchResultsVar);
export const setFiltersFromSearchResults = createSetFiltersFromSearchResults(filtersVar);
